import { useMemo } from "react";
import { useLocation, matchPath } from "react-router";
import { useSelector } from "react-redux";
import _ from "lodash";

export default () => {
    const location = useLocation();
    const services = useSelector(state => state.app.services);

    const isAddWorkingEnvironmentService = (service) => {
        return matchPath(location.pathname, `/add-working-environment/${service.key}/:provider?/:isHa?/:createOrDiscover`);
    }

    return useMemo(() => {
        const service = _.find(services, service => {
            const serviceTo = _.get(service, "service.to");
            if (service.suite && service.suite !== "CloudManager") {
                return false;
            }
            const addWorkingEnvironmentService = isAddWorkingEnvironmentService(service);
            return addWorkingEnvironmentService || (serviceTo && matchPath(location.pathname, serviceTo));
        })
        if (service) {
            const addWorkingEnvironmentService = isAddWorkingEnvironmentService(service);
            const hideSelectedServiceNav = addWorkingEnvironmentService || _.get(service, "isServiceNavHidden");
            service.isShowingSelectedServiceNav = hideSelectedServiceNav === undefined ? !service.service?.isServiceIntegration : !hideSelectedServiceNav;
            const pathString = location.pathname.lastIndexOf('/') === location.pathname.length - 1 ? location.pathname.slice(0, -1) : location.pathname;
            const subTabPath = pathString.substring(pathString.lastIndexOf('/'))
            service.selectedSubTab = service.uiIntegration?.subTabs?.find(subtab => subtab.to === subTabPath)
        }
        return service;
    }, [location.pathname, services]);
}
